import { gql, GraphQLClient } from 'graphql-request';

import { NetworkIds } from '~config/rpcConfig';
import { systemStateQuery, transactionQuery } from '~services/subgraph/queries';

import { GetLiquidatedTroveStatsRes, LiquidationStatsRes } from './types';

export default class Liquidations {
  constructor(private readonly client: GraphQLClient, private readonly networkId: NetworkIds) {}

  async getUserLiquidatedTroves(user: string, asset: string) {
    const troveId = `${user.toLowerCase()}-${asset.toLowerCase()}`;
    const liquidatedTroveQuery = gql`
      query get_liquidated_trove_stats($id: ID) {
        trove(id: $id) {
          changes(where: { liquidation_not: null }) {
            ${systemStateQuery}
            liquidation {
              id
              asset { 
                name
              }
              sequenceNumber
              liquidator { 
                  id 
              }
              liquidatedDebt
              liquidatedCollateral
              collGasCompensation
              tokenGasCompensation
              ${transactionQuery}
            }
          }
        }
      }
    `;

    const res: GetLiquidatedTroveStatsRes = await this.client.request(liquidatedTroveQuery, {
      asset,
      id: troveId,
    });

    return res.trove.changes.map(({ systemStateAfter, systemStateBefore, liquidation }) => ({
      systemStateBefore,
      systemStateAfter,
      ...liquidation,
    }));
  }

  async getAssetLiquidationStats(asset: string) {
    const liquidationStatsQuery = gql`
      query get_liquidation_stats($asset: ID) {
        assetStat(id: $asset) {
          numberOfLiquidatedTroves
          liquidationCollatTotal
          liquidationDebtTotal
        }
        liquidations(first: 1000, where: { asset: $asset }, orderBy: sequenceNumber, orderDirection: desc) {
          sequenceNumber
          liquidatedCollateral
          liquidatedDebt
          transaction {
            id
            blockNumber
            timestamp
          }
        }
      }
    `;

    const res: LiquidationStatsRes = await this.client.request(liquidationStatsQuery, { asset });

    return res;
  }
}
